import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { Injectable } from '@angular/core';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from './types/filter.types';
import { socialServiceOfferGroupFrag } from './types/social-service-offer-group.types';
import {
    SocialServiceOfferGroupGridObject,
    SocialServiceOfferGroupObject,
} from '@libs/types/src/services/object-type/service/social-service/social-service-offer-group.object';
import {
    SocialServiceOfferGroupCreateInput,
} from '@libs/types/src/services/input-type/services/social-service/social-service-offer-group.create-input';
import {
    SocialServiceOfferGroupUpdateInput,
} from '@libs/types/src/services/input-type/services/social-service/social-service-offer-group.update-input';
import {
    SocialServiceOfferGroupAddOffersInput,
} from '@libs/types/src/services/input-type/services/social-service/social-service-offer-group.add-offers-input';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';

@Injectable({
    providedIn: 'root',
})
export class SocialServiceOfferGroupGqlServiceV2 extends GqlServiceV2 {

    public async getSocialServiceOfferGroups(input: GridInput, frag: string = socialServiceOfferGroupFrag) {
        return this.query<SocialServiceOfferGroupGridObject>(
            `
                query($input: GridInput!) {
                  socialServiceOfferGroup {
                    filter(input: $input) {
                      ${filterFrag}
                      items {
                        ${frag}
                      }
                    }
                  }
                }
              `,
            { input },
        );
    }

    public async createSocialServiceOfferGroup(input: SocialServiceOfferGroupCreateInput, frag: string = socialServiceOfferGroupFrag) {
        return this.mutate<SocialServiceOfferGroupObject>(
            `
                mutation($input: SocialServiceOfferGroupCreateInput!) {
                  socialServiceOfferGroup {
                    create(input: $input) {
                      ${frag}
                    }
                  }
                }
              `,
            { input },
        );
    }

    public async updateSocialServiceOfferGroup(input: SocialServiceOfferGroupUpdateInput, frag: string = socialServiceOfferGroupFrag) {
        return this.mutate<SocialServiceOfferGroupObject>(
            `
                mutation($input: SocialServiceOfferGroupUpdateInput!) {
                  socialServiceOfferGroup {
                    update(input: $input) {
                      ${frag}
                    }
                  }
                }
              `,
            { input },
        );
    }

    public async addOffersToSocialServiceOfferGroup(input: SocialServiceOfferGroupAddOffersInput, frag: string = socialServiceOfferGroupFrag) {
        return this.mutate<SocialServiceOfferGroupObject[]>(
            `
                mutation($input: SocialServiceOfferGroupAddOffersInput!) {
                  socialServiceOfferGroup {
                    addOffers(input: $input) {
                      ${frag}
                    }
                  }
                }
              `,
            { input },
        );
    }

    public async deleteSocialServiceOfferGroup(input: IdInput, frag: string = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                  socialServiceOfferGroup {
                    delete(input: $input) {
                      ${frag}
                    }
                  }
                }
              `,
            { input },
        );
    }
}

